(function() {
    'use strict';

    var BusinessInvoiceFieldCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, xmsNotificationFactory) {

        console.log("Inside BusinessInvoiceFieldCtrl");

        if( !angular.isDefined(passedModel) ){
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }

        console.log("INSIDE CandidateReferenceCtrl");
        $scope.fieldControlModel = passedModel;

       $scope.fnSaveFieldControls = function($event) {
            console.log("INSIDE fnSaveFieldControls");
            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/businessInvoiceDetails/saveFieldControls?";
            var data = $scope.fieldControlModel;
            console.log(data)
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.fieldControlModel[result.data.fieldName].displayControlClass = result.data.fieldClass;
                    xmsNotificationFactory.addObj({id: "fieldControlPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.fieldControlModel);
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later..";
                    xmsNotificationFactory.addObj({id: "fieldControlPop", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.close($scope.fieldControlModel);
                }
            );
            $event.preventDefault();
        }

        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }

        $scope.cancel = function() {
           $uibModalInstance.dismiss('cancel');
        }


    }
    BusinessInvoiceFieldCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','ajaxCall','params','xmsNotificationFactory'];
    angular.module('app').controller('BusinessInvoiceFieldCtrl', BusinessInvoiceFieldCtrl);

}());